// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"28f21477","196":"4542a237","288":"154f0733","359":"9f2b9334","635":"55cf05aa","637":"ce3d6785","669":"2fd66a3b","718":"64019007","777":"6a94303c","869":"bcd0e113","989":"57f60576"}[chunkId] + ".chunk.css";
};